<div class="relative flex items-center justify-center">
  <input
    #searchInput
    type="text"
    class="w-[500px] p-3 border-2 border-dnv-primary bg-white rounded-full focus:outline-dnv-secondary placeholder:text-dnv-primary"
    [placeholder]="'NAVBAR.SEARCHBAR.PLACEHOLDER' | translate"
    [value]="textSearch()"
    (input)="onInput($event)"
    (keydown.enter)="onSubmit()"
  />
  <button
    class="absolute top-1 right-1 h-[calc(100%-0.5rem)] bg-dnv-secondary hover:bg-dnv-secondary/70 text-white py-1 px-3 rounded-full text-sm cursor-pointer disabled:bg-slate-300"
    (click)="onSubmit()"
  >
    {{ 'NAVBAR.SEARCHBAR.BUTTON' | translate }}
  </button>
</div>
